<template>
  <div>
    <v-menu ref="menu2" :close-on-content-click="false" v-model="menu2" :nudge-right="40" :return-value.sync="date" lazy transition="scale-transition" offset-y full-width min-width="290px">
      <v-text-field slot="activator" v-model="date" :label="label" prepend-icon="event" readonly></v-text-field>
      <v-date-picker v-model="date" @input="$refs.menu2.save(date)" :min="min" :max="max"></v-date-picker>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: "seleccione fecha"
    },
    value: {
      type: String
    },
    min: {
      type: String
    },
    max: {
      type: String
    }
  },
  data() {
    return {
      date: this.value,
      menu: false,
      modal: false,
      menu2: false
    };
  },
  watch: {
    date(value) {
      this.$emit("input", value);
    }
  }
};
</script>
